<template>
  <article class="">

    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">Nueva empresa</p>
              <v-breadcrumbs class="breadcums">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                  @click="$router.push({name: 'agreements_index'})"
                  class="breadcums__option"
                >
                  Convenios
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  disabled
                  class="breadcums__disable"
                >
                  Nueva empresa
                </v-breadcrumbs-item>
              </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-0">
              <button
                class="faccess_button px-5"
                @click="createInvitation(errors.any())"
              >
                Crear
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <div class="agreement__new py-0 px-0 mt-0">
          <div class="agreement__new--column">
            <p class="table_card__info--label">Empresa</p>
            <v-text-field
              name="organization_name"
              single-line
              v-validate="'required'"
              label="Nombre de la empresa"
              type="text"
              solo
              v-model="agreement.attributes.user_info_attributes.attributes.organization_name">
            </v-text-field>
            <p  :class="errors.has('organization_name')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('organization_name')?'El nombre de la empresa es requerido':''}}</p>
            <p class="table_card__info--label">Usuario a cargo</p>
            <v-text-field
              name="user_name"
              single-line
              label="Nombre usuario a cargo"
              type="text"
              v-validate="'required|alpha_spaces'"
              v-model="agreement.attributes.user_info_attributes.attributes.name"
              solo
            >
            </v-text-field>
            <p  :class="errors.has('user_name')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('user_name')?'El nombre del usuario encargado es incorrecto':''}}</p>


            <p class="table_card__info--label">Contraseña</p>
            <v-text-field
              single-line
              name="password"
              label="Crear contraseña"
              :append-icon="eye ? 'visibility' : 'visibility_off'"
              :type="eye ? 'text' : 'password'"
              @click:append="eye = !eye"
              v-validate="{required: true, regex:/^.{6,}$/}"
              v-model="agreement.attributes.password"
              solo
            >
            </v-text-field>
            <p  :class="errors.has('password')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('password')?'La contraseña debe tener al menos 6 dígitos':''}}</p>

          </div>
          <div class="agreement__new--column">
            <p class="table_card__info--label">NIT</p>
            <v-text-field
              single-line
              name="nit"
              label="Número NIT"
              v-validate="'required'"
              type="text"
              v-model="agreement.attributes.user_info_attributes.attributes.nit"
              solo
            >
            </v-text-field>
            <p  :class="errors.has('nit')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('nit')?'El NIT es requerido':''}}</p>
            <p class="table_card__info--label">Correo del usuario a cargo</p>
            <v-text-field
              single-line
              name="email"
              v-validate="{required: true, regex:/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/}"
              label="Correo del usuario a cargo"
              type="text"
              v-model="agreement.attributes.email"
              solo
            >
            </v-text-field>
            <p  :class="errors.has('email')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('email')?'El formato del correo es incorrecto':''}}</p>

            <p class="table_card__info--label">Número de pases</p>
            <v-text-field
              single-line
              name="quantity"
              label="Cantidad de pases"
              v-validate="'required|numeric|min_value:0'"
              type="number"
              v-model="agreement.attributes.user_info_attributes.attributes.agreement_entries_quantities_attributes[0].quantity"
              solo
            >
            </v-text-field>
            <p  :class="errors.has('quantity')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('quantity')?'El número de pases es incorrecto':''}}</p>

          </div>
        </div>
      </div>
      <div class="table_card__footer">
        <button
          class="faccess_button px-5"
          @click="createInvitation(errors.any())"
        >
          Crear
        </button>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data(){
    return{
      eye:false,
      agreement: {
        attributes: {
          email:"",
          mobile:"",
          password:"",
          user_info_type:"AgreementAdminUser",
          user_info_attributes: {
            attributes: {
              name:"",
              last_name:"",
              organization_name:"",
              nit:"",
              agreement_entries_quantities_attributes:[
                {
                  quantity:""
                }
              ]
            }
          }
        },
      }
    }
  },
  methods:{
    createInvitation(has_errors){
      let vm = this;
      // cl agreement
      if(this.checkEmptySpaces()&&!has_errors){
        try {
          this.$http.post('agreements/create_user', {
            data: this.encrypt(this.agreement).toString()
          },
          {headers:{
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }}).then(function(response){
            this.$router.push({name: 'agreements_index'})
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if (response.body.data.message != null &&
                response.body.data.message != undefined &&
                response.body.data.message != '' ){
                alert(response.body.data.message)
            }else{
              alert(response.body.data)
            }
          })
        } catch (e) {
          alert(e.message)
        }
      }
      else{
        this.$validator.validateAll();
      }


    },
    checkEmptySpaces(){
      var empty=false;
      if(this.agreement.attributes.email!=''&&this.agreement.attributes.password!=''&&this.agreement.attributes.user_info_attributes.attributes.name!=''
      &&this.agreement.attributes.user_info_attributes.attributes.organization_name!=''&&this.agreement.attributes.user_info_attributes.attributes.nit!=''
      &&this.agreement.attributes.user_info_attributes.attributes.agreement_entries_quantities_attributes.quantity!=''){
        empty=true;
      }
      return empty;
    }
  }
}
</script>
<style >
  .agreement__new--error_container {
    font-size: 12px;
    color: #FF5F6D;
    margin-bottom: 20px;
    margin-top: -15px;
  }

  .agreement__new--column input{
    font: normal normal normal 16px/25px 'Poppins' !important;
    letter-spacing: 0px !important;
    color: #5A6B8E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/agreements/New.vue